import { render, staticRenderFns } from "./ActivityWelfareLf.vue?vue&type=template&id=9effbf6e"
import script from "./ActivityWelfareLf.vue?vue&type=script&lang=js"
export * from "./ActivityWelfareLf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports